import get from 'lodash/get';
import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectState = (state: ApplicationRootState) =>
    state.app.configs || initialState;

export const selectCampaignBudgetTypeOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.budgetTypeOptions.campaign');
    }
);

export const selectCampaignPacingOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.pacingOptions.campaign');
    }
);

export const selectCampaignGoalTypeOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.goalTypeOptions.campaign');
    }
);

export const selectEditCampaignStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.statusOptions.editCampaign');
    }
);

export const selectEditClientStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.statusOptions.editCampaign');
    }
);

export const selectCreateCampaignStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.statusOptions.createCampaign');
    }
);

export const selectAdGroupBudgetTypeOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.budgetTypeOptions.adGroup');
    }
);

export const selectAdGroupPacingOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.pacingOptions.adGroup');
    }
);

export const selectAdGroupGoalTypeOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.goalTypeOptions.adGroup');
    }
);

export const selectEditAdGroupStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.statusOptions.editAdGroup');
    }
);

export const selectCreateAdGroupStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.statusOptions.createAdGroup');
    }
);

export const selectBulkEditStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.statusOptions.bulkEdit');
    }
);

export const selectTableCellStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.statusOptions.tableCell');
    }
);

export const selectFontFamilyOptions = createSelector(selectState, (state) => {
    return get(state, 'styles.fontFamilyOptions');
});

export const selectCuisineOptions = createSelector(selectState, (state) => {
    return get(state, 'options.cuisineOptions');
});

export const selectUserHistoryOptions = createSelector(selectState, (state) => {
    return get(state, 'options.userHistoryOptions');
});

export const selectOrderValueOptions = createSelector(selectState, (state) => {
    return get(state, 'options.orderValueOptions');
});

export const selectUserStatusOptions = createSelector(selectState, (state) => {
    return get(state, 'options.userStatusOptions');
});

export const selectAdvertiserStatusOptions = createSelector(
    selectState,
    (state) => {
        return get(state, 'options.advertiserStatusOptions');
    }
);

export const selectEntityAttributes = createSelector(selectState, (state) => {
    return get(state, 'tableColumns.entityTableColumns.data.attributes');
});

export const selectMinifiedEntityAttributes = createSelector(
    selectState,
    (state) => {
        return get(
            state,
            'tableColumns.entityTableColumns.data.minified_attributes'
        );
    }
);

export const selectEntityTableColumnsStatus = createSelector(
    selectState,
    (state) => {
        return get(state, 'tableColumns.entityTableColumns.status');
    }
);
